// extracted by mini-css-extract-plugin
export default {"logo":"PzInH","subtitle":"untSI","time":"SwkVb","live":"x23Pl","subtitle-content":"qduV1","subtitleContent":"qduV1","date":"BHJx4"};